import React, {useEffect, useState} from 'react';
import {motion, AnimatePresence} from "framer-motion";
import "./View.css";
import { Insets } from '@vkontakte/vk-bridge';
import {isNotchedPhoneFromApple} from "./utils";

let View = (props) => {
    let [curPanel, setPanel] = useState(<div>Панель это who (кто)?</div>);
    let [nav, setNav] = useState(false);
    let [insets, setInsets] = useState({});
    let [noNav, setNoNav] = useState("");


    // Changing panels
    useEffect(()=>{
            props.children.forEach((child)=>{
                if (props.activePanel === child.props.id) {
                    setPanel(child);
                }
            })
        },
        [props.activePanel, props.children]);

    // Generating responsive menubar/sidebar TODO: depends on viewport properties (tablet,phone,desktop)
    useEffect(()=>{
            if(isNotchedPhoneFromApple()){
                setInsets({paddingTop:44, paddingBottom:21});
            }

            if (props.navs) {
                setNoNav("")
                let navbarItems = [];
                let navbarItemId = -1
                ;
                props.navs.forEach((navItem)=>{
                    navbarItemId++;
                    navItem.id = navbarItemId;
                    if (!navItem.type) {
                        navbarItems.push(
                            <div onClick={navItem.action} className={navItem.selected ? "NavBar--item NavBar--selected" : "NavBar--item"}>
                                <div className="NavBar--item_content">
                                    <div className="NavBar--icon">
                                        {navItem.icon}
                                    </div>
                                    <div className="NavBar--name">
                                        {navItem.name}
                                    </div>
                                </div>
                            </div>
                        );
                    } else {
                        navbarItems.push(
                            <div onClick={navItem.action} className="NavBar--bottomfix">
                                {navItem.items}
                            </div>
                        );
                    }

                    setNav(
                        <div className="NavBar">
                            {navbarItems}
                        </div>
                    );
                })
            }else{
                setNav(false);
                if (noNav===""){
                    setNoNav("View--panel_no_nav")
                };
            }
        },
        [props.navs]);


    return (
        <div className="View" style={insets}>
            <div id="View--panel" className={"View--panel "+noNav}>
                <AnimatePresence exitBeforeEnter={true}>
                    <motion.div
                        initial={{ opacity: 0, x: -100 }}
                        animate={{ scale: 1, opacity:1, x:0 }}
                        exit={{}}
                        key={props.activePanel}
                    >
                        {curPanel}
                    </motion.div>
                </AnimatePresence>
            </div>
            {props.alert ?
                <AnimatePresence exitBeforeEnter={true}>
                    {props.alert}
                </AnimatePresence>
                : false}
            {nav ?
                <div className="View--nav">
                    {nav}
                </div> :
                ""}
        </div>
    );
}
export default View;
